import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { WatchList } from '~/shared/data-contract/watch';

import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { jobArchitectureKeys } from './query-keys';

export const useWatches = (): UseQueryResult<WatchList, Error> => {
    const { listWatches } = useApplicationFetchers();

    return useQuery<WatchList, Error>({
        queryFn: async () => {
            const result = await listWatches();

            if (result.isErr) {
                throw result.error;
            }

            return result.value;
        },
        queryKey: jobArchitectureKeys.watches(),
        staleTime: 60_000,
        throwOnError: false,
    });
};

export const useIsWatched = (itemId: string): boolean => {
    const { data: watches = [] } = useWatches();

    return watches.some((watch) => watch.itemId === itemId && watch.explicit);
};
